import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PaymentParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Payment {
  id?: number;
  branchId: any;
  paymentDate: any;
  receiverType: string;
  expenseType: string;
  supplierId?: any;
  employeeId?: any;
  expenseId: any;
  notes?: string;
  othersName?: string;
  othersAddress?: string;
  othersPhone?: string;
  expenseNo?: string;
  netAmount: number;
  physicianId?: any;
  tenantId: any;
  ipBillId: any;
  parameters?: PaymentParameter[];
  links?: any;
  cancelBillId?: number;
  counterId?: number;
  refundPaymentType?: string;
  DpBillId?: number;
  paidAmount?: number;
  advanceId?: number;
  alternatePhoneType?: string,
  alternatePhoneNumber?: any,
  createdBy?: number | string,
  createdDate?: Date,
  updatedBy?: number | string,
  updatedDate?: Date,
  createdIp?:  string,
  updatedIp?:  string,
  opBillId?:number,
  phSalesReturnId?:number,
  regId?:string
  accountCode?:'HMS'
  allowEdit?:'Y'|'N',
  lock?:Boolean,
  approvalId?:number,
  paymentsDet?: PaymentDetail[];
  phSupPayments?: any[];
  approvalDet?:any

}
export interface PaymentDetail {
    id?:any;
    paymentId :any;
    referenceBank? :any;
    referenceNo? :string;
    createdBy :any;
    createdDate :any;
    purchaseNo?:string;
    billInvoiceNo? :string;
    paymentType :string;
    cash? :number;
    card? :number;
    onlineTransfer?:number; 
    chequeDD? :number;
    branchId :any;
    tenantId :any;
     parameters?: PaymentParameter[];
    links?: any;

    cardType?:string;
    upiPaymentId?:string;
    checkNo?:string;
    netBanking?:string;
    alternatePhoneType?:string,
    alternatePhoneNumber?:any

}
export interface PaymentSearchData{
     paymentId :any;
    paymentDetailId :any;
    paymentDate :any;
      expenseType :string;
    receiverType :string;
    supplierId? :any;
    employeeId? :any;
    physicianId? :any;
    othersName?:string;
    othersPhone? :string;
    othersAddress? :string;
    //receiverName:string;
    expenseNo :string;
    expenseId :any;
    //expenseName:string;
    netAmount:number;
    notes? :string;
     createdBy :any;
    //createdName:string;
   createdDate :any;
     paymentType :string;
    cash? :number;
    card? :number;
    onlineTransfer?:number; 
    chequeDD? :number;
    //AmountPaid :number;
    referenceBank? :any;
    referenceNo? :string;
    purchaseNo?:string;
    billInvoiceNo? :string;
    parameters?: PaymentParameter[];
    links?: any;
    allowEdit:string;
    patientName?:string;
    patientMobile?:string;
    regId?:string;
     billNum:string;
     regNum?:string;
}


export abstract class PaymentData {
 
  
  abstract list(url: string): Observable<Payment[]>;
  abstract create(url: string,data: Payment): Observable<any>;
  abstract createForAny(url: string,data:any): Observable<any>;
  abstract updateothersincome(url: string,data:any): Observable<any>;
  abstract update(url: string,data: Payment): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract getById(url: string,options?: any): Observable<Payment>;
abstract getOtherById(url: string,options?: any): Observable<any>;
  abstract detailList(url: string): Observable<PaymentDetail[]>;
  abstract createDetail(url: string,data: PaymentDetail): Observable<any>;
  abstract updateDetail(url: string,data: PaymentDetail): Observable<any>;
  abstract deleteDetail(url: string): Observable<any>;
    abstract getByDetailId(url: string,options?: any): Observable<PaymentDetail>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract frontList(url:string):Observable<PaymentSearchData[]>;
  abstract createDetailMultiple(url: string,data: PaymentDetail[]): Observable<any>;
  abstract  setPaymentSearchData( paymentSearchData: PaymentSearchData,task:string):void;
  abstract getPaymentSearchData():PaymentSearchData;
  abstract isAnySearchDataAvailable():boolean;
  abstract deletePaymentSearchData():void;
  abstract getTaskName():string;

}

